module.exports = __webpack_public_path__ + "static/media/error.4c8cd6ea.m4a";